import React, { useContext } from 'react';
import FilterInput from '../../../components/filter-input';

import { id } from '../../../../filters/options/item-name';

import { AdvancedSearchOrderContext } from '../../context';

import messages from './messages';

const ItemNameFilter = () => {
  const { filters, updateFilter } = useContext(AdvancedSearchOrderContext);

  return <FilterInput filters={filters} id={id} labelMessage={messages.itemName} updateFilter={updateFilter} />;
};

export default ItemNameFilter;
